﻿import $ from 'jquery';
import _ from 'underscore';

declare global {
  interface JQuery {
    fillwindow(): JQuery;
  }
}
(function ($) {

  $.fn.fillwindow = function () {
    $(this).each(function () {
      let $this = $(this);

      let newSize = 0;
      let thisTop = $(this).offset().top;
      let footerSelector = $this.data('footer');
      let footerSize = 0;
      if (footerSelector) {
        let $footer = $('footer-content'.asDataSelector(footerSelector));
        if ($footer.length <= 0)
          throw new Error('fillwindow: unable to find footer with selector ' + footerSelector);
        footerSize = $footer.height();
      }

      let offset = $this.is('[data-no-offset]') ? 0 : 35;
      newSize = $(window).height() - thisTop - footerSize - offset;

      $this.height(newSize);
    });
    return $(this);
  };

  $(window).on('resize.rustig.fillwindow', _.throttle(() => $('[data-fillwindow]').fillwindow(), 250));

  $(function () {
    $('[data-fillwindow]').fillwindow();
  });

  $(document).ajaxComplete(function () {
    $('[data-fillwindow]').fillwindow();
  });

})($);
